import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {AppToastService} from '../../../shared/services/util/app-toast.service';
import {UserService} from '../../administration/shared/services/user.service';
import {UtilityService} from '../../../shared/services/util/utility.service';
import {CryptoService} from '../../../shared/services/crypto.service';
import {ConfirmedValidator} from '../../administration/shared/validators/confirmed.validator';
import {AuthenticationService} from '../../../shared/services/authentication.service';
import {Login} from '../../../shared/models/login';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class PasswordComponent implements OnInit {

  formGroup: UntypedFormGroup;
  toasterConfig: any;
  hidePassword = true;
  hidePasswordCtrl = true;

  constructor(private authenticationService: AuthenticationService,
              private activatedRoute: ActivatedRoute,
              private appToastService: AppToastService,
              private userService: UserService,
              public utilityService: UtilityService,
              private cryptoService: CryptoService,
              private formBuilder: UntypedFormBuilder) {
    this.toasterConfig = this.appToastService.getConfig();
  }

  ngOnInit() {
    this.createForm(this.authenticationService.currentUserValue);
  }

  private createForm(login: Login): void {
    this.formGroup = this.formBuilder.group({
      id: new UntypedFormControl(login.session.publicid),
      username: new UntypedFormControl({value: login.session.username, disabled: true}),
      password: new UntypedFormControl('', [
        Validators.required,
        ConfirmedValidator.validPatternPassword(/[0-9]/, {hasNumber: true}),
        ConfirmedValidator.validPatternPassword(/[A-Z]/, {hasCapitalCase: true}),
        ConfirmedValidator.validPatternPassword(/[a-z]/, {hasSmallCase: true}),
        ConfirmedValidator.validPatternPassword(/[@#$%^&+=]/, {hasSpecialCharacters: true}),
        Validators.minLength(8),
        Validators.maxLength(16)
      ]),
      passwordctrl: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(16)
      ]),
      enabled: new UntypedFormControl(login.session.enabled),
      profiles: new UntypedFormControl(login.session.profile)
    }, {
      validators: [ConfirmedValidator.validMatchPassword('password', 'passwordctrl')]
    });
  }

  getErrorPassword(): string {
    return this.fg.password.hasError('required') ? 'You must enter a value' :
      this.fg.password.hasError('minlength') ? 'Not a valid password minim length 8' :
        this.fg.password.hasError('maxlength') ? 'Not a valid password maxim length 16' :
          this.fg.password.hasError('hasNumber') ? 'Not a valid password number required' :
            this.fg.password.hasError('hasCapitalCase') ? 'Not a valid password upper case letter required' :
              this.fg.password.hasError('hasSmallCase') ? 'Not a valid password lower case letter required' :
                this.fg.password.hasError('hasSpecialCharacters') ? 'Not a valid password special character required' :
                  '';
  }

  getErrorPasswordCtrl(): string {
    return this.fg.passwordctrl.hasError('required') ? 'You must enter a value' :
      this.fg.passwordctrl.hasError('minlength') ? 'Not a valid password control minim length 8' :
        this.fg.passwordctrl.hasError('maxlength') ? 'Not a valid password control maxim length 16' :
          this.fg.passwordctrl.hasError('matching') ? 'Password and Confirm Password do not match' :
            '';
  }

  // convenience getter for easy access to form fields
  get fg() {
    return this.formGroup.controls;
  }

  onSubmit(): void {
    const data = {
      id: this.fg.id.value,
      username: this.fg.username.value,
      password: this.cryptoService.encrypt(this.fg.password.value),
      passwordctrl: this.cryptoService.encrypt(this.fg.passwordctrl.value),
      enabled: this.fg.enabled.value,
      profiles: this.fg.profiles.value
    };
    this.userService.put(data).subscribe(
      () => {
        this.authenticationService.logout();
      },
      (error) => {
        this.appToastService.error('Error', error);
      });
  }

}
